import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';

interface ArticleSummary {
  slug: string;
  title: string;
  description: string;
  date: string; // ISO string
  author?: string;
}

// Simple SEO helpers without adding new deps
function setPageSEO(title: string, description: string) {
  if (typeof document !== 'undefined') {
    document.title = title;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description);
  }
}

// Articles data (duplicated light import to keep page cohesive)
export const articles: ArticleSummary[] = [
  {
    slug: 'how-ai-is-transforming-understanding-ourselves-and-relationships',
    title: 'How AI Is Transforming the Way We Understand Ourselves and Our Relationships',
    description: 'A practical look at how AI can deepen self-awareness and improve relationship dynamics through everyday language and behavior insights.',
    date: '2025-01-21',
    author: 'WeSonder Team',
  },
];

export default function BlogListPage() {
  useEffect(() => {
    setPageSEO(
      'WeSonder Blog — Psychology, Relationships, and AI Insights',
      'Articles on emotional intelligence, relationship dynamics, and how AI can help you build better self-awareness and connection.'
    );
  }, []);

  return (
    <div className="bg-white">
      <header className="bg-slate-50 border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-slate-900">WeSonder Articles</h1>
          <p className="mt-3 text-slate-600 max-w-3xl">
            Practical, research-informed writing on emotional intelligence, relationship dynamics, and how to use AI for real growth.
          </p>
        </div>
      </header>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid gap-6">
        {articles.map((a) => (
          <Card key={a.slug} className="hover:shadow-md transition-shadow">
            <CardContent className="p-6">
              <div className="text-sm text-slate-500">
                {new Date(a.date).toLocaleDateString(undefined, {
                  year: 'numeric', month: 'long', day: 'numeric'
                })}
                {a.author ? ` · ${a.author}` : ''}
              </div>
              <h2 className="mt-2 text-xl font-semibold text-slate-900">
                <Link to={`/blog/${a.slug}`} className="hover:underline">
                  {a.title}
                </Link>
              </h2>
              <p className="mt-2 text-slate-600">{a.description}</p>
              <div className="mt-4">
                <Link to={`/blog/${a.slug}`} className="text-blue-600 hover:text-blue-700 font-medium">
                  Read article →
                </Link>
              </div>
            </CardContent>
          </Card>
        ))}
      </section>
    </div>
  );
}


